var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item,i){return _c('div',{key:i},[_c('v-btn',{staticClass:"w-full flex justify-start my-2",on:{"click":function($event){return _vm.onSubmit(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }